
import { Link } from 'react-router-dom';
import { PRODUCTS } from './productsInfo'; 
import { Header } from '../../components/atoms/Header';


export default function ProductList() {

    return (
        <>
            <Header />
        <div className="mt-9 mx-auto  max-w-xl lg:max-w-4xl">
            <div className="mt-16 sm:mt-20">
                <div className="-my-4 grid justify-contentn-center grid-cols-2 sm:grid-cols-2 lg:grid-cols-3 gap-2 py-6 sm:gap-8">
                    {PRODUCTS.map((product, productsIndex) => (
                        <Link to={`/product/${productsIndex + 1}`} className='flex flex-col items-center '>
                            <div
                                key={productsIndex}
                                className=
                                'relative aspect-[9/10] w-36 h-36 mx-auto overflow-hidden rounded-xl bg-zinc-100 dark:bg-zinc-800 sm:w-72 sm:h-72 sm:rounded-2xl'
                            >
                                <img
                                    src={product.image}
                                    alt=""
                                    sizes="(min-width: 640px) 18rem, 11rem"
                                    className="absolute inset-0 h-full w-full object-cover"
                                />

                            </div>
                            
                            <h1 className="mt-3 p-3 text-center text-md sm:text-2xl hover:text-orange-800 font-bold tracking-tight text-zinc-800 dark:text-zinc-100 ">{product.name}</h1>
                        </Link>
                    ))}
                </div>
            </div>
            </div>
            </>
    )
}